import { ActionCreatorWithPayload, createAction } from '@reduxjs/toolkit'

import { ChartFeeType } from './index'
import { ISetCurrencyAmountPayload } from './types'

export const setCurrenciesAmountsAndWlpAction: ActionCreatorWithPayload<ISetCurrencyAmountPayload> = createAction(
  'strategy/addLiquidity/setCurrencyAmount'
)
export const setSelectedFeeAction: ActionCreatorWithPayload<ChartFeeType> = createAction(
  'strategy/addLiquidity/setSelectedFee'
)
